module.exports = __webpack_public_path__ + "img/pc-script.53f73626.webp";